import React, { useState } from 'react';
import { AppPageWrapper, Title, Button } from 'components';
import { useIsMobile } from 'components/hooks';
import BillingInfo from 'templates/app/billing';
import { BackButton, SaveButton } from 'templates/app/style';
import BackIcon from 'assets/image/icons/app/back.svg';

const items = [
  {
    id: 'billingInfo',
    label: 'Billing Info'
  },
  {
    id: 'paymentMethod',
    label: 'Payment Method'
  },
  {
    id: 'billingHistory',
    label: 'Billing History'
  },
];

const Billing: React.VFC = () => {
  const [tab, setTab] = useState('');
  const isMobile = useIsMobile();
  const selectedLabel = items.find((item) => item.id === tab);

  return (
    <AppPageWrapper
      title={isMobile && selectedLabel ? selectedLabel.label : 'Billing'}
    >
      <div className="main-content-container xs-p-0">
        {isMobile && selectedLabel && (
          <>
            <BackButton onClick={() => setTab('')}>
              <BackIcon />{' '}Back
            </BackButton>
            {tab !== 'billingHistory' && <SaveButton>Save</SaveButton>}
          </>
        )}
        {!isMobile && (
          <Title
            title={'Billing'}
            description={'Lorem Ipsum has been the industry`s standard.'}
          >
            <Button round>Save</Button>
          </Title>
        )}
        <div className="main-content-body">
          <div className="main-content-wrapper">
            <BillingInfo tab={tab} setTab={setTab} />
          </div>
        </div>
      </div>
    </AppPageWrapper>
  );
};

export default Billing;
